// extracted by mini-css-extract-plugin
export default {"box":"ActiveLessons_box__bHc3d","content":"ActiveLessons_content__c+t0S"};